var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loadedComponent)?_c(_setup.loadedComponent,_vm._g(_vm._b({ref:_setup.setChildrenRefs,tag:"component",scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_vm._t("default",null,null,slotProps ?? {})]}}],null,true)},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }